
<div class="title has-text-centered">Are you a <br/>business or charity?</div>

<div class="block has-text-centered">
  <button class="button is-primary" on:click={onBusiness}
    >I'm a business</button>
</div>
<div class="block has-text-centered"><p>Businesses offer items.</p></div>


<div class="block has-text-centered">
  <button class="button is-primary" on:click={onCharity}
    >I'm a charity</button
  >
</div>
<div class="block has-text-centered"><p>Charities receive items.</p></div><div class="block has-text-centered"><p>You must be a Registered Charity, Community Interest Company, Community Benefit Society or have an HMRC charity tax status.</p></div>

<script lang="ts">
  import { goto } from "@sveltech/routify";
  import { appState } from "../../lib/appState";

  if($appState.user) {
    if ($appState.user!.company) {
      $goto("start/business/personal");
    } else if ($appState.user!.charity) {
      $goto("start/charity/personal");
    } else if ($appState.user!.isAdmin) {
      $goto("admin");
    }
  }

  function onBusiness() {
    $goto("start/business/personal");
  }

  function onCharity() {
    $goto("start/charity/personal");
  }
</script>
